<i18n>
{
	"en": {
		"title": "Changelog",
		"noChanges": "There have been no changes to this order.",
		"close": "Close",
		"date": "Date",
		"user": "User",
		"order": "Main Order",
		"newValue": "New Value",
		"oldValue": "Old Value",
		"changeLocation": "Change Location",
		"removedSuborder": "Deleted Suborder",
		"newOrder": "Created",
		"newSubOrder": "Created",
		"showDetails": "Show Details",
		"field": "Field",
		"includeSubOrders": "Include Suborder Changelogs",

		"additionalReferences": "Additional References",
		"additionalReferences.code": "Additional References - Code",
		"additionalReferences.value": "Additional References - Text",
		"ata": "ATA",
		"ata.date": "ATA",
		"ataIsLocked": "ATA Locked",
		"atd": "ATD",
		"atd.date": "ATD",
		"atdIsLocked": "ATD Locked",
		"billingType": "Billing Type",
		"chargableWeight": "Chargable Weight",
		"clerk": "Clerk",
		"clerk.email": "Clerk Email",
		"clerk.name": "Clerk Name",
		"consignee": "Consignee",
		"consignee.contactEmail": "Consignee - Email",
		"consignee.contactName": "Consignee - Contact Name",
		"consignee.contactPhone": "Consignee - Phone Number",
		"consignee.country": "Consignee - Country",
		"consignee.countryCode": "Consignee - Country Code",
		"consignee.customerNumber": "Consignee - Customer Number",
		"consignee.customsCreditNumber": "Consignee - Customs Credit Number",
		"consignee.eori": "Consignee - EORI",
		"consignee.exporterNumber": "Consignee - Exporter Number",
		"consignee.gs1LocationNumber": "Consignee - GS1 Locno.",
		"consignee.marks": "Consignee - Marks",
		"consignee.name": "Consignee - Name",
		"consignee.organizationNumber": "Consignee - Organization Number",
		"consignee.postalCode": "Consignee - Postal Code",
		"consignee.postalPlace": "Consignee - Postal Place",
		"consignee.street": "Consignee - Street",
		"consignee.vat": "Consignee - MVA",
		"consignee.vendorNumber": "Consignee - Vendor Number",
		"consignee.voec": "Consignee - VOEC",
		"consignee.website": "Consignee - Website",
		"consigneeReference": "Consignee Ref",
		"consignor": "Consignor",
		"consignor.contactEmail": "Consignor - Email",
		"consignor.contactName": "Consignor - Contact Name",
		"consignor.contactPhone": "Consignor - Phone Number",
		"consignor.country": "Consignor - Country",
		"consignor.countryCode": "Consignor - Country Code",
		"consignor.customerNumber": "Consignor - Customer Number",
		"consignor.customsCreditNumber": "Consignor - Customs Credit Number",
		"consignor.eori": "Consignor - EORI",
		"consignor.exporterNumber": "Consignor - Exporter Number",
		"consignor.gs1LocationNumber": "Consignor - GS1 Locno.",
		"consignor.marks": "Consignor - Marks",
		"consignor.name": "Consignor - Name",
		"consignor.organizationNumber": "Consignor - Organization Number",
		"consignor.postalCode": "Consignor - Postal Code",
		"consignor.postalPlace": "Consignor - Postal Place",
		"consignor.street": "Consignor - Street",
		"consignor.vat": "Consignor - MVA",
		"consignor.vendorNumber": "Consignor - Vendor Number",
		"consignor.voec": "Consignor - VOEC",
		"consignor.website": "Consignor - Website",
		"currency": "Currency",
		"customer": "Customer",
		"customer.contactEmail": "Customer - Contact Email",
		"customer.contactName": "Customer - Contact Name",
		"customer.countryCode": "Customer - Country Code",
		"customer.customerNo": "Customer Number",
		"customer.name": "Customer - Name",
		"customer.postalCode": "Customer - Postal Code",
		"customer.postalPlace": "Customer - Postal Place",
		"customer.street": "Customer - Street",
		"customer.address": "Customer - Address",
		"customer.currency": "Customer - Currency",
		"customersReference": "Customers Ref",
		"deliveryParty": "Delivery Party",
		"deliveryParty.contactEmail": "Delivery Party - Email",
		"deliveryParty.contactName": "Delivery Party - Contact Name",
		"deliveryParty.contactPhone": "Delivery Party - Phone Number",
		"deliveryParty.country": "Delivery Party - Country",
		"deliveryParty.countryCode": "Delivery Party - Country Code",
		"deliveryParty.customerNumber": "Delivery Party - Customer Number",
		"deliveryParty.customsCreditNumber": "Delivery Party - Customs Credit Number",
		"deliveryParty.eori": "Delivery Party - EORI",
		"deliveryParty.exporterNumber": "Delivery Party - Exporter Number",
		"deliveryParty.gs1LocationNumber": "Delivery Party - GS1 Locno.",
		"deliveryParty.marks": "Delivery Party - Marks",
		"deliveryParty.name": "Delivery Party - Name",
		"deliveryParty.organizationNumber": "Delivery Party - Organization Number",
		"deliveryParty.postalCode": "Delivery Party - Postal Code",
		"deliveryParty.postalPlace": "Delivery Party - Postal Place",
		"deliveryParty.street": "Delivery Party - Street",
		"deliveryParty.vat": "Delivery Party - MVA",
		"deliveryParty.vendorNumber": "Delivery Party - Vendor Number",
		"deliveryParty.voec": "Delivery Party - VOEC",
		"deliveryParty.website": "Delivery Party - Website",
		"despatchParty": "Despatch Party",
		"despatchParty.contactEmail": "Despatch Party - Email",
		"despatchParty.contactName": "Despatch Party - Contact Name",
		"despatchParty.contactPhone": "Despatch Party - Phone Number",
		"despatchParty.country": "Despatch Party - Country",
		"despatchParty.countryCode": "Despatch Party - Country Code",
		"despatchParty.customerNumber": "Despatch Party - Customer Number",
		"despatchParty.customsCreditNumber": "Despatch Party - Customs Credit Number",
		"despatchParty.eori": "Despatch Party - EORI",
		"despatchParty.exporterNumber": "Despatch Party - Exporter Number",
		"despatchParty.gs1LocationNumber": "Despatch Party - GS1 Locno.",
		"despatchParty.marks": "Despatch Party - Marks",
		"despatchParty.name": "Despatch Party - Name",
		"despatchParty.organizationNumber": "Despatch Party - Organization Number",
		"despatchParty.postalCode": "Despatch Party - Postal Code",
		"despatchParty.postalPlace": "Despatch Party - Postal Place",
		"despatchParty.street": "Despatch Party - Street",
		"despatchParty.vat": "Despatch Party - MVA",
		"despatchParty.vendorNumber": "Despatch Party - Vendor Number",
		"despatchParty.voec": "Despatch Party - VOEC",
		"despatchParty.website": "Despatch Party - Website",
		"documents": "Documents",
		"economicalStatus": "Economical Status",
		"edi": "EDI",
		"edi.transmissions": "EDI",
		"eta": "ETA",
		"eta.date": "ETA",
		"etd": "ETD",
		"etd.date": "ETD",
		"events": "Events",
		"goodsListFreeText": "Free Text - Goods List",
		"invoiceFreeText": "Free Text - Invoice",
		"loadingListFreeText": "Free Text - Loading List",
		"transporterInstructions": "Free Text - Waybill",
		"freightLines": "Freight Lines",
		"freightLines.description": "Freight Line - Description",
		"freightLines.grossWeight": "Freight Line - Gross Weight",
		"freightLines.height": "Freight Line - Height",
		"freightLines.length": "Freight Line - Length",
		"freightLines.marks": "Freight Line - Marks",
		"freightLines.netWeight": "Freight Line - Net Weight",
		"freightLines.numberOfPallets": "Freight Line - Number of Pallets",
		"freightLines.numberOfUnits": "Freight Line - Number of Units",
		"freightLines.packageTypeCode": "Freight Line - Package Type Code",
		"freightLines.palletPackageCode": "Freight Line - Pallet Type",
		"freightLines.palletPackageTypeCode": "Freight Line - Package Type",
		"freightLines.palletPriceFactorPrice": "Freight Line - P.P. Price",
		"freightLines.palletPriceFactorTruck": "Freight Line - P.P. Car",
		"freightLines.chargableWeight": "Freight Line - Chargable Weight",
		"freightLines.loadingMeters": "Freight Line - Loading Meters",
		"freightLines.volume": "Freight Line - Volume",
		"freightLines.width": "Freight Line - Width",
		"goodsType": "Goods Type",
		"goodsType.alternativeName": "Goods Type - Alternative Name",
		"goodsType.maxTemperature": "Goods Type -  Max Temp.",
		"goodsType.minTemperature": "Goods Type - Min. Temp.",
		"goodsType.name": "Goods Type - Name",
		"goodsType.tpxCode": "Goods Type - TPX Code",
		"grossWeight": "Gr. Weight",
		"incotermsCode": "Incoterms Code",
		"incotermsPlace": "Incoterms Postal Place",
		"internalNotes": "Internal Notes",
		"invoiceCurrency": "Invoice Currency",
		"invoiceCurrencyPrice": "Invoice Price",
		"invoiceDate.date": "Invoice Date",
		"invoiceNumber": "Invoice Number",
		"loadingMeters": "Loading Meters",
		"manuallyPriced": "Manually Priced",
		"mayGenerateReturnOrder": "May Generate Return Order",
		"numberOfPackages": "Number of Packages",
		"numberOfPallets": "Number of Pallets",
		"orderNumber": "Order Number",
		"orderType.alternativeName": "Order Type - Alternative Name",
		"orderType.code": "Order Type - Code",
		"orderType.name": "Order Type - Name",
		"orderType": "Order Type",
		"originalShipper": "Original Shipper",
		"originalShipper.contactEmail": "Original Shipper - Email",
		"originalShipper.contactName": "Original Shipper - Contact Name",
		"originalShipper.contactPhone": "Original Shipper - Phone Number",
		"originalShipper.country": "Original Shipper - Country",
		"originalShipper.countryCode": "Original Shipper - Country Code",
		"originalShipper.customerNumber": "Original Shipper - Customer Number",
		"originalShipper.customsCreditNumber": "Original Shipper - Customs Credit Number",
		"originalShipper.eori": "Original Shipper - EORI",
		"originalShipper.exporterNumber": "Original Shipper - Exporter Number",
		"originalShipper.gs1LocationNumber": "Original Shipper - GS1 Locno.",
		"originalShipper.marks": "Original Shipper - Marks",
		"originalShipper.name": "Original Shipper - Name",
		"originalShipper.organizationNumber": "Original Shipper - Organization Number",
		"originalShipper.postalCode": "Original Shipper - Postal Code",
		"originalShipper.postalPlace": "Original Shipper - Postal Place",
		"originalShipper.street": "Original Shipper - Street",
		"originalShipper.vat": "Original Shipper - MVA",
		"originalShipper.vendorNumber": "Original Shipper - Vendor Number",
		"originalShipper.voec": "Original Shipper - VOEC",
		"originalShipper.website": "Original Shipper - Website",
		"packages": "Packages",
		"packages.licencePlate": "Packages - Licence Plate",
		"poReference": "PO Ref",
		"priceLines": "Price Lines",
		"priceLines.chargeCode": "Price Lines - Code",
		"priceLines.currencyVat": "Price Lines - Currency MVA",
		"priceLines.originalCurrencyAmount": "Price Lines - Original Currency Amount",
		"priceLines.currencyAmount": "Price Lines - Currency Amount",
		"priceLines.amount": "Price Lines - Amount",
		"priceLines.vatCode": "Price Lines - MVA Code",
		"priceLines.text": "Price Lines - Text",
		"registeredDate.date": "Registered Date",
		"sendersReference": "Senders Ref",
		"status": "Status",
		"totalPrice": "Total Price",
		"transporterInstructions": "Transporter Instructions",
		"volume": "Volume",
		"waybillNumber": "Waybill no.",
		"tripNumber": "Trip Number",
		"overage": "Overage",
		"shortage": "Shortage",
		"originalDespatchParty": "Original Despatch Party",
		"originalDespatchParty.contactEmail": "Original Despatch Party - Email",
		"originalDespatchParty.contactName": "Original Despatch Party - Contact Name",
		"originalDespatchParty.contactPhone": "Original Despatch Party - Phone Number",
		"originalDespatchParty.country": "Original Despatch Party - Country",
		"originalDespatchParty.countryCode": "Original Despatch Party - Country Code",
		"originalDespatchParty.customerNumber": "Original Despatch Party - Customer Number",
		"originalDespatchParty.customsCreditNumber": "Original Despatch Party - Customs Credit Number",
		"originalDespatchParty.eori": "Original Despatch Party - EORI",
		"originalDespatchParty.exporterNumber": "Original Despatch Party - Exporter Number",
		"originalDespatchParty.gs1LocationNumber": "Original Despatch Party - GS1 Locno.",
		"originalDespatchParty.marks": "Original Despatch Party - Marks",
		"originalDespatchParty.name": "Original Despatch Party - Name",
		"originalDespatchParty.organizationNumber": "Original Despatch Party - Organization Number",
		"originalDespatchParty.postalCode": "Original Despatch Party - Postal Code",
		"originalDespatchParty.postalPlace": "Original Despatch Party - Postal Place",
		"originalDespatchParty.street": "Original Despatch Party - Street",
		"originalDespatchParty.vat": "Original Despatch Party - MVA",
		"originalDespatchParty.vendorNumber": "Original Despatch Party - Vendor Number",
		"originalDespatchParty.voec": "Original Despatch Party - VOEC",
		"originalDespatchParty.website": "Original Despatch Party - Website",
		"finalDeliveryParty": "Final Delivery Party",
		"finalDeliveryParty.contactEmail": "Final Delivery Party - Email",
		"finalDeliveryParty.contactName": "Final Delivery Party - Contact Name",
		"finalDeliveryParty.contactPhone": "Final Delivery Party - Phone Number",
		"finalDeliveryParty.country": "Final Delivery Party - Country",
		"finalDeliveryParty.countryCode": "Final Delivery Party - Country Code",
		"finalDeliveryParty.customerNumber": "Final Delivery Party - Customer Number",
		"finalDeliveryParty.customsCreditNumber": "Final Delivery Party - Customs Credit Number",
		"finalDeliveryParty.eori": "Final Delivery Party - EORI",
		"finalDeliveryParty.exporterNumber": "Final Delivery Party - Exporter Number",
		"finalDeliveryParty.gs1LocationNumber": "Final Delivery Party - GS1 Locno.",
		"finalDeliveryParty.marks": "Final Delivery Party - Marks",
		"finalDeliveryParty.name": "Final Delivery Party - Name",
		"finalDeliveryParty.organizationNumber": "Final Delivery Party - Organization Number",
		"finalDeliveryParty.postalCode": "Final Delivery Party - Postal Code",
		"finalDeliveryParty.postalPlace": "Final Delivery Party - Postal Place",
		"finalDeliveryParty.street": "Final Delivery Party - Street",
		"finalDeliveryParty.vat": "Final Delivery Party - MVA",
		"finalDeliveryParty.vendorNumber": "Final Delivery Party - Vendor Number",
		"finalDeliveryParty.voec": "Final Delivery Party - VOEC",
		"finalDeliveryParty.website": "Final Delivery Party - Website",
		"wasSent": "Sent",
		"pendingDeliveryParty": "Pending Delivery Party",
		"appMessages": "App Messages",
		"vendor": "Transporter",
		"vendor.name": "Transporter - Name",
		"vendor.orgNo": "Transporter - Organization Number",
		"vendor.vendorNumber": "Transporter - Vendor Number",
		"vendor.countryCode": "Transporter - Country Code",
		"vendor.postalCode": "Transporter - Postal Code",
		"vendor.postalPlace": "Transporter - Postal Place",
		"vendor.street": "Transporter - Street",
		"loadingSeqNo": "Loading Sequence",

		"aborted": "Cancelled",
		"notCleared": "Not cleared",
		"settlement": "Ready for settlement",
		"invoice": "Ready for invoice",
		"unknown": "Unknown",
		"draft": "Draft",
		"received": "Received",
		"rejected": "Rejected",
		"ready": "Ready",
		"planned": "Planned",
		"unsuccessful": "Unsuccessful",
		"requested": "Requested",
		"accepted": "Accepted",
		"selectStatus": "Select status",
		"readyForPickup": "Ready for pickup",
		"loaded": "Loaded",
		"unloaded": "Unloaded",
		"incomplete": "Incomplete",
		"notSettled": "Not settled",
		"settled": "Settled",
		"invoiced": "Invoiced",
		"recorded": "Recorded",
		"collected": "Collected",
		"delivered": "Delivered",
		"appSend": "Sent to Confirm",
		"info": "Information",
		"ediInstructionReceived": "Inbound EDI",
		"ediInstructionSent": "Outbound EDI",
		"ediTrackAndTraceSent" : "Outbound EDI",
		"packageEvents": "Package Events",
		"inbound": "Inbound",
		"outbound": "Outbound",
		"collectFreeText": "Driver Collect Comment",
		"deliverFreeText": "Driver Delivery Comment"
	},
	"no": {
		"title": "Endringer",
		"noChanges": "Ingen endringer registrert på dette oppdraget.",
		"close": "Close",
		"date": "Dato",
		"user": "Bruker",
		"order": "Hovedoppdrag",
		"newValue": "Ny verdi",
		"oldValue": "Gammel verdi",
		"changeLocation": "Endre",
		"removedSuborder": "Slettet suborder",
		"newOrder": "Laget",
		"newSubOrder": "Laget",
		"showDetails": "Vis detaljer",
		"field": "Field",
		"includeSubOrders": "Inkluder suborder endringer",

		"additionalReferences": "Andre Referanser",
		"additionalReferences.code": "Andre Referanser - Kode",
		"additionalReferences.value": "Andre Referanser - Tekst",
		"ata": "ATA",
		"ata.date": "ATA",
		"ataIsLocked": "ATA låst",
		"atd": "ATD",
		"atd.date": "ATD",
		"atdIsLocked": "ATD låst",
		"billingType": "Faktureringstype",
		"chargableWeight": "Fraktberegningsvekt",
		"clerk": "Ansvarlig",
		"clerk.email": "Ansvarlig - epost",
		"clerk.name": "Ansvarlig - Navn",
		"consignee": "Mottaker",
		"consignee.contactEmail": "Mottaker - E-post",
		"consignee.contactName": "Mottaker - Contact navn",
		"consignee.contactPhone": "Mottaker - Telefon",
		"consignee.country": "Mottaker - Land",
		"consignee.countryCode": "Mottaker - Landkode",
		"consignee.customerNumber": "Mottaker - Kunde",
		"consignee.customsCreditNumber": "Mottaker - Tollkredittnummber",
		"consignee.eori": "Mottaker - EORI",
		"consignee.exporterNumber": "Mottaker - Eksportør nummer",
		"consignee.gs1LocationNumber": "Mottaker - GS1 Locno.",
		"consignee.marks": "Mottaker - Merknader",
		"consignee.name": "Mottaker - Navn",
		"consignee.organizationNumber": "Mottaker - Foretaksnummer",
		"consignee.postalCode": "Mottaker - Postnummer",
		"consignee.postalPlace": "Mottaker - Poststed",
		"consignee.street": "Mottaker - Gate",
		"consignee.vat": "Mottaker - MVA",
		"consignee.vendorNumber": "Mottaker - Leverandør",
		"consignee.voec": "Mottaker - VOEC",
		"consignee.website": "Mottaker - Internett",
		"consigneeReference": "Mottaker Ref",
		"consignor": "Avsender",
		"consignor.contactEmail": "Avsender - E-post",
		"consignor.contactName": "Avsender - Contact navn",
		"consignor.contactPhone": "Avsender - Telefon",
		"consignor.country": "Avsender - Land",
		"consignor.countryCode": "Avsender - Landkode",
		"consignor.customerNumber": "Avsender - Kunde",
		"consignor.customsCreditNumber": "Avsender - Tollkredittnummber",
		"consignor.eori": "Avsender - EORI",
		"consignor.exporterNumber": "Avsender - Eksportør nummer",
		"consignor.gs1LocationNumber": "Avsender - GS1 Locno.",
		"consignor.marks": "Avsender - Merknader",
		"consignor.name": "Avsender - Navn",
		"consignor.organizationNumber": "Avsender - Foretaksnummer",
		"consignor.postalCode": "Avsender - Postnummer",
		"consignor.postalPlace": "Avsender - Poststed",
		"consignor.street": "Avsender - Gate",
		"consignor.vat": "Avsender - MVA",
		"consignor.vendorNumber": "Avsender - Leverandør",
		"consignor.voec": "Avsender - VOEC",
		"consignor.website": "Avsender - Internett",
		"currency": "Valuta",
		"customer": "Kunde",
		"customer.contactEmail": "Kunde - E-post",
		"customer.contactName": "Kunde - Contact Navn",
		"customer.countryCode": "Kunde - Landkode",
		"customer.customerNo": "Kundenr.",
		"customer.name": "Kunde - Navn",
		"customer.postalCode": "Kunde - Postnummer",
		"customer.postalPlace": "Kunde - Poststed",
		"customer.street": "Kunde - Gate",
		"customer.address": "Kunde - Adresse",
		"customer.currency": "Customer - Valuta",
		"customersReference": "Kunde Ref",
		"deliveryParty": "Leveringsaddresse",
		"deliveryParty.contactEmail": "Leveringsaddresse - E-post",
		"deliveryParty.contactName": "Leveringsaddresse - Contact navn",
		"deliveryParty.contactPhone": "Leveringsaddresse - Telefon",
		"deliveryParty.country": "Leveringsaddresse - Land",
		"deliveryParty.countryCode": "Leveringsaddresse - Landkode",
		"deliveryParty.customerNumber": "Leveringsaddresse - Kunde",
		"deliveryParty.customsCreditNumber": "Leveringsaddresse - Tollkredittnummber",
		"deliveryParty.eori": "Leveringsaddresse - EORI",
		"deliveryParty.exporterNumber": "Leveringsaddresse - Eksportør nummer",
		"deliveryParty.gs1LocationNumber": "Leveringsaddresse - GS1 Locno.",
		"deliveryParty.marks": "Leveringsaddresse - Merknader",
		"deliveryParty.name": "Leveringsaddresse - Navn",
		"deliveryParty.organizationNumber": "Leveringsaddresse - Foretaksnummer",
		"deliveryParty.postalCode": "Leveringsaddresse - Postnummer",
		"deliveryParty.postalPlace": "Leveringsaddresse - Poststed",
		"deliveryParty.street": "Leveringsaddresse - Gate",
		"deliveryParty.vat": "Leveringsaddresse - MVA",
		"deliveryParty.vendorNumber": "Leveringsaddresse - Leverandør",
		"deliveryParty.voec": "Leveringsaddresse - VOEC",
		"deliveryParty.website": "Leveringsaddresse - Internett",
		"despatchParty": "Henteaddresse",
		"despatchParty.contactEmail": "Henteaddresse - E-post",
		"despatchParty.contactName": "Henteaddresse - Contact navn",
		"despatchParty.contactPhone": "Henteaddresse - Telefon",
		"despatchParty.country": "Henteaddresse - Land",
		"despatchParty.countryCode": "Henteaddresse - Landkode",
		"despatchParty.customerNumber": "Henteaddresse - Kunde",
		"despatchParty.customsCreditNumber": "Henteaddresse - Tollkredittnummber",
		"despatchParty.eori": "Henteaddresse - EORI",
		"despatchParty.exporterNumber": "Henteaddresse - Eksportør nummer",
		"despatchParty.gs1LocationNumber": "Henteaddresse - GS1 Locno.",
		"despatchParty.marks": "Henteaddresse - Merknader",
		"despatchParty.name": "Henteaddresse - Navn",
		"despatchParty.organizationNumber": "Henteaddresse - Foretaksnummer",
		"despatchParty.postalCode": "Henteaddresse - Postnummer",
		"despatchParty.postalPlace": "Henteaddresse - Poststed",
		"despatchParty.street": "Henteaddresse - Gate",
		"despatchParty.vat": "Henteaddresse - MVA",
		"despatchParty.vendorNumber": "Henteaddresse - Leverandør",
		"despatchParty.voec": "Henteaddresse - VOEC",
		"despatchParty.website": "Henteaddresse - Internett",
		"documents": "Dokumenter",
		"economicalStatus": "Økonomisk status",
		"edi": "EDI",
		"edi.transmissions": "EDI",
		"eta": "ETA",
		"eta.date": "ETA",
		"etd": "ETD",
		"etd.date": "ETD",
		"events": "Hendelser",
		"events.signatureName": "Hendelser - Signatur",
		"goodsListFreeText": "Fritekst - Godsliste",
		"invoiceFreeText": "Fritekst - Faktura",
		"loadingListFreeText": "Fritekst - Lasteliste",
		"transporterInstructions": "Fritekst - Fraktbrev",
		"freightLines": "Fraktlinjer",
		"freightLines.description": "Fraktlinje - Beskrivelse",
		"freightLines.grossWeight": "Fraktlinje - Brutto vekt",
		"freightLines.height": "Fraktlinje - Høyde",
		"freightLines.length": "Fraktlinje - Lengde",
		"freightLines.marks": "Fraktlinje - Merknader",
		"freightLines.netWeight": "Fraktlinje - Netto vekt",
		"freightLines.numberOfPallets": "Fraktlinje - Paller",
		"freightLines.numberOfUnits": "Fraktlinje - Antall",
		"freightLines.packageTypeCode": "Fraktlinje - Kode",
		"freightLines.palletPackageCode": "Fraktlinje - Palletype",
		"freightLines.palletPackageTypeCode": "Fraktlinje - Pakketype",
		"freightLines.palletPriceFactorPrice": "Fraktlinje - P.P. Pris",
		"freightLines.palletPriceFactorTruck": "Fraktlinje - P.P. Bil",
		"freightLines.chargableWeight": "Fraktlinje - Fraktberegningsvekt",
		"freightLines.loadingMeters": "Fraktlinje - Lastemeter",
		"freightLines.volume": "Fraktlinje - Volum",
		"freightLines.width": "Fraktlinje - Bredde",
		"goodsType": "Godstyper",
		"goodsType.alternativeName": "Godstyper - Alternativt navn",
		"goodsType.maxTemperature": "Godstyper - Maks temp.",
		"goodsType.minTemperature": "Godstyper - Min. temp.",
		"goodsType.name": "Godstyper - Navn",
		"goodsType.tpxCode": "Godstyper - Kode",
		"grossWeight": "Br. vekt",
		"incotermsCode": "Incoterms kode",
		"incotermsPlace": "Incoterms poststed",
		"internalNotes": "Interne notater",
		"invoiceCurrency": "Faktura-valuta",
		"invoiceCurrencyPrice": "Faktura-pris",
		"invoiceDate.date": "Faktura dato",
		"invoiceNumber": "Fakturanummer",
		"loadingMeters": "Lastemeter",
		"manuallyPriced": "Manuelt priset",
		"mayGenerateReturnOrder": "Kan generere returoppdrag",
		"numberOfPackages": "Antall pakker",
		"numberOfPallets": "Antall paller",
		"orderNumber": "Order Number",
		"orderType": "Oppdragstype",
		"orderType.alternativeName": "Oppdragstype - Alternativt navn",
		"orderType.code": "Oppdragstype - Kode",
		"orderType.name": "Oppdragstype - Navn",
		"originalShipper": "Original avsender",
		"originalShipper.contactEmail": "Original avsender - E-post",
		"originalShipper.contactName": "Original avsender - Contact navn",
		"originalShipper.contactPhone": "Original avsender - Telefon",
		"originalShipper.country": "Original avsender - Land",
		"originalShipper.countryCode": "Original avsender - Landkode",
		"originalShipper.customerNumber": "Original avsender - Kunde",
		"originalShipper.customsCreditNumber": "Original avsender - Tollkredittnummber",
		"originalShipper.eori": "Original avsender - EORI",
		"originalShipper.exporterNumber": "Original avsender - Eksportør nummer",
		"originalShipper.gs1LocationNumber": "Original avsender - GS1 Locno.",
		"originalShipper.marks": "Original avsender - Merknader",
		"originalShipper.name": "Original avsender - Navn",
		"originalShipper.organizationNumber": "Original avsender - Foretaksnummer",
		"originalShipper.postalCode": "Original avsender - Postnummer",
		"originalShipper.postalPlace": "Original avsender - Poststed",
		"originalShipper.street": "Original avsender - Gate",
		"originalShipper.vat": "Original avsender - MVA",
		"originalShipper.vendorNumber": "Original avsender - Leverandør",
		"originalShipper.voec": "Original avsender - VOEC",
		"originalShipper.website": "Original avsender - Internett",
		"packages": "Pakker",
		"poReference": "PO Ref",
		"priceLines": "Prislinjer",
		"priceLines.chargeCode": "Prislinjer - Kode",
		"priceLines.currencyVat": "Prislinjer - Valuta MVA",
		"priceLines.originalCurrencyAmount": "Prislinjer - Original valuta beløp",
		"priceLines.currencyAmount": "Prislinjer - Valuta beløp",
		"priceLines.amount": "Prislinjer - Amount",
		"priceLines.vatCode": "Prislinjer - MVA Kode",
		"priceLines.text": "Prislinjer - Tekst",
		"registeredDate.date": "Registrert dato",
		"sendersReference": "Avsender ref",
		"status": "Status",
		"totalPrice": "Total pris",
		"transporterInstructions": "Transportør instruksjoner",
		"volume": "Volum",
		"waybillNumber": "Fraktbrevnr",
		"tripNumber": "Turnummer",
		"overage": "Overage",
		"shortage": "Shortage",
		"originalDespatchParty": "Original henteaddresse",
		"originalDespatchParty.contactEmail": "Original henteaddresse - E-post",
		"originalDespatchParty.contactName": "Original henteaddresse - Contact navn",
		"originalDespatchParty.contactPhone": "Original henteaddresse - Telefon",
		"originalDespatchParty.country": "Original henteaddresse - Land",
		"originalDespatchParty.countryCode": "Original henteaddresse - Landkode",
		"originalDespatchParty.customerNumber": "Original henteaddresse - Kunde",
		"originalDespatchParty.customsCreditNumber": "Original henteaddresse - Tollkredittnummber",
		"originalDespatchParty.eori": "Original henteaddresse - EORI",
		"originalDespatchParty.exporterNumber": "Original henteaddresse - Eksportør nummer",
		"originalDespatchParty.gs1LocationNumber": "Original henteaddresse - GS1 Locno.",
		"originalDespatchParty.marks": "Original henteaddresse - Merknader",
		"originalDespatchParty.name": "Original henteaddresse - Navn",
		"originalDespatchParty.organizationNumber": "Original henteaddresse - Foretaksnummer",
		"originalDespatchParty.postalCode": "Original henteaddresse - Postnummer",
		"originalDespatchParty.postalPlace": "Original henteaddresse - Poststed",
		"originalDespatchParty.street": "Original henteaddresse - Gate",
		"originalDespatchParty.vat": "Original henteaddresse - MVA",
		"originalDespatchParty.vendorNumber": "Original henteaddresse - Leverandør",
		"originalDespatchParty.voec": "Original henteaddresse - VOEC",
		"originalDespatchParty.website": "Original henteaddresse - Internett",
		"finalDeliveryParty": "Endelig leveringsadresse",
		"finalDeliveryParty.contactEmail": "Endelig leveringsadresse - E-post",
		"finalDeliveryParty.contactName": "Endelig leveringsadresse - Contact navn",
		"finalDeliveryParty.contactPhone": "Endelig leveringsadresse - Telefon",
		"finalDeliveryParty.country": "Endelig leveringsadresse - Land",
		"finalDeliveryParty.countryCode": "Endelig leveringsadresse - Landkode",
		"finalDeliveryParty.customerNumber": "Endelig leveringsadresse - Kunde",
		"finalDeliveryParty.customsCreditNumber": "Endelig leveringsadresse - Tollkredittnummber",
		"finalDeliveryParty.eori": "Endelig leveringsadresse - EORI",
		"finalDeliveryParty.exporterNumber": "Endelig leveringsadresse - Eksportør nummer",
		"finalDeliveryParty.gs1LocationNumber": "Endelig leveringsadresse - GS1 Locno.",
		"finalDeliveryParty.marks": "Endelig leveringsadresse - Merknader",
		"finalDeliveryParty.name": "Endelig leveringsadresse - Navn",
		"finalDeliveryParty.organizationNumber": "Endelig leveringsadresse - Foretaksnummer",
		"finalDeliveryParty.postalCode": "Endelig leveringsadresse - Postnummer",
		"finalDeliveryParty.postalPlace": "Endelig leveringsadresse - Poststed",
		"finalDeliveryParty.street": "Endelig leveringsadresse - Gate",
		"finalDeliveryParty.vat": "Endelig leveringsadresse - MVA",
		"finalDeliveryParty.vendorNumber": "Endelig leveringsadresse - Leverandør",
		"finalDeliveryParty.voec": "Endelig leveringsadresse - VOEC",
		"finalDeliveryParty.website": "Endelig leveringsadresse - Internett",
		"wasSent": "Sent",
		"pendingDeliveryParty": "Avventer Leveringsadresse",
		"appMessages": "App Meldinger",
		"vendor": "Transportør",
		"vendor.name": "Transportør - Navn",
		"vendor.orgNo": "Transportør - Foretaksnummer",
		"vendor.vendorNumber": "Transportør - Leverandørnummer",
		"vendor.countryCode": "Transportør - Landkode",
		"vendor.postalCode": "Transportør - Postnummer",
		"vendor.postalPlace": "Transportør - Poststed",
		"vendor.street": "Transportør - Gate",
		"loadingSeqNo": "Lastesekvens",
		"aborted": "Annullert",
		"notCleared": "Ikke klarert",
		"settlement": "Klar for avregning",
		"invoice": "Klar for fakturering",
		"unknown": "Ukjent",
		"cancelled": "Annullert",
		"draft": "Kladd",
		"received": "Mottatt",
		"rejected": "Avslått",
		"ready": "Klar",
		"planned": "Planlagt",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Akseptert",
		"selectStatus": "Velg status",
		"readyForPickup": "Klar for henting",
		"loaded": "Lastet",
		"unloaded": "Losset",
		"incomplete": "Ufullstendig",
		"notSettled": "Ikke klarert",
		"settled": "Klarert",
		"invoiced": "Oppgjort",
		"recorded": "Bokført",
		"collected": "Hentet",
		"delivered": "Levert",
		"appSend": "Sendt til Confirm",
		"info": "Informasjon",
		"ediInstructionReceived": "Inngående EDI",
		"ediInstructionSent": "Utgående EDI",
		"ediTrackAndTraceSent" : "Utgående EDI",
		"packageEvents": "Pakkehendelser",
		"inbound": "Inngående",
		"outbound": "Utgående",
		"collectFreeText": "App hentetekst",
		"deliverFreeText": "App leveringstekst"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:title="$t('title')"
		:hasConfirm="false"
		:cancelLabel="$t('close')"
		icon="history"
		iconType="bp"
		iconColor="blue"
		width="1600px"
		@close="$emit('close')"
	>
		<div slot="title-after" class="include-suborders-checkbox">
			<t-checkbox
				:checked="includeSubOrders"
				:label="$t('includeSubOrders')"
				@change="toggleIncludeSubOrders"
			/>
		</div>
		<t-horizontal-panel
			style="height: 690px; width: 1566px;"
			:showRightPanel="showDetailsVisible"
		>
			<template>
				<t-grid
					v-if="changelog && changelog.length > 0"
					:items="filteredChangelog"
					:columnDefinitions="columnDefinitions"
					:defaultColumnDefinition="defaultColumnDefinition"
					:rowHeight="40"
					:sort="sort"
					style="height: 690px; width: 1566px;"
				>
					<template v-slot:clerk="{ displayValue }">
						<div v-if="displayValue" style="height: 16px;">
							<template v-if="displayValue.name">
								{{displayValue.name}}
							</template>
							<template v-else-if="displayValue.email">
								{{displayValue.email}}
							</template>
							<template v-else-if="displayValue.phoneNumber">
								{{displayValue.phoneNumber}}
							</template>
						</div>
						<div v-if="displayValue && displayValue.name" class="grid-cell-sub-line">
							<template v-if="displayValue.email">
								{{displayValue.email}}
							</template>
							<template v-else-if="displayValue.phoneNumber">
								{{displayValue.phoneNumber}}
							</template>
						</div>
					</template>
					<template v-slot:oldValue="{ item, displayValue }">
						<div v-if="isObject(displayValue)" class="grid-cell-details">
							<DetailsCell
								v-if="item.field === 'additionalReferences'"
								:mainValue="displayValue.code"
								:subValue="displayValue.value"
							/>
							<DetailsCell
								v-else-if="isAddressField(item.field)"
								:mainValue="displayValue.name"
								:subValue="`${displayValue.street}, ${displayValue.postalCode} ${displayValue.postalPlace}`"
							/>
							<DetailsCell
								v-else-if="item.field === 'clerk'"
								:mainValue="displayValue.name"
								:subValue="displayValue.email"
							/>
							<DetailsCell
								v-else-if="item.field === 'customer'"
								:mainValue="displayValue.name"
								:subValue="displayValue.customerNo"
							/>
							<DetailsCell
								v-else-if="item.field === 'edi.transmissions'"
								:mainValue="`${$t(displayValue.type)} ${displayValue.messageType}`"
								:subValue="getStorageDate(displayValue.created.date)"
							/>
							<DetailsCell
								v-else-if="item.field === 'events' || item.field === 'packageEvents'"
								:mainValue="$t(displayValue.type)"
								:subValue="getEventText(displayValue)"
							/>
							<DetailsCell
								v-else-if="item.field === 'freightLines'"
								:mainValue="displayValue.text"
								:subValue="displayValue.chargeCode"
							/>
							<DetailsCell
								v-else-if="item.field === 'goodsType'"
								:mainValue="displayValue.name"
							/>
							<DetailsCell
								v-else-if="item.field === 'orderType'"
								:mainValue="displayValue.name"
							/>
							<DetailsCell
								v-else-if="item.field === 'priceLines'"
								:mainValue="displayValue.text"
								:subValue="displayValue.chargeCode"
							/>
							<DetailsCell
								v-else-if="item.field === 'vendor'"
								:mainValue="displayValue.name"
								:subValue="displayValue.vendorNumber"
							/>
							<t-button
								v-if="allowDetailsButton(item.field)"
								appearance="primary"
								type="bp"
								@click="showDetails(item.field, item.op, item.oldValue)"
							>{{ $t('showDetails') }}</t-button>
						</div>
						<div v-else>
							{{ displayValue }}
						</div>
					</template>
					<template v-slot:value="{ item, displayValue }">
						<div v-if="isObject(displayValue)" class="grid-cell-details">
							<DetailsCell
								v-if="item.field === 'additionalReferences'"
								:mainValue="displayValue.code"
								:subValue="displayValue.value"
							/>
							<DetailsCell
								v-else-if="isAddressField(item.field)"
								:mainValue="displayValue.name"
								:subValue="`${displayValue.street}, ${displayValue.postalCode} ${displayValue.postalPlace}`"
							/>
							<DetailsCell
								v-else-if="item.field === 'clerk'"
								:mainValue="displayValue.name"
								:subValue="displayValue.email"
							/>
							<DetailsCell
								v-else-if="item.field === 'customer'"
								:mainValue="displayValue.name"
								:subValue="displayValue.customerNo"
							/>
							<DetailsCell
								v-else-if="item.field === 'edi.transmissions'"
								:mainValue="`${$t(displayValue.type)} ${displayValue.messageType}`"
								:subValue="getStorageDate(displayValue.created.date)"
							/>
							<DetailsCell
								v-else-if="item.field === 'events' || item.field === 'packageEvents'"
								:mainValue="$t(displayValue.type)"
								:subValue="getEventText(displayValue)"
							/>
							<DetailsCell
								v-else-if="item.field === 'freightLines'"
								:mainValue="displayValue.text"
								:subValue="displayValue.chargeCode"
							/>
							<DetailsCell
								v-else-if="item.field === 'goodsType'"
								:mainValue="displayValue.name"
							/>
							<DetailsCell
								v-else-if="item.field === 'orderType'"
								:mainValue="displayValue.name"
							/>
							<DetailsCell
								v-else-if="item.field === 'priceLines'"
								:mainValue="displayValue.text"
								:subValue="displayValue.chargeCode"
							/>
							<DetailsCell
								v-else-if="item.field === 'vendor'"
								:mainValue="displayValue.name"
								:subValue="displayValue.vendorNumber"
							/>

							<t-button
								v-if="allowDetailsButton(item.field)"
								appearance="primary"
								type="bp"
								@click="showDetails(item.field, item.op, item.value)"
							>{{ $t('showDetails') }}</t-button>
						</div>
						<div v-else>
							{{ displayValue }}
						</div>
					</template>
				</t-grid>
				<t-no-content-panel
					v-else
					:text="$t('noChanges')"
					icon="history"
					iconType="bp"
					class="log-content"
					noBetweenGap
				/>
			</template>

			<template v-slot:right >
				<AdditionalReference
					v-if="showDetailsVisible && detailsField === 'additionalReferences'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<Address
					v-if="showDetailsVisible && isAddressField(detailsField)"
					:field="detailsField"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<Clerk
					v-if="showDetailsVisible && detailsField === 'clerk'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<Customer
					v-if="showDetailsVisible && detailsField === 'customer'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<Event
					v-if="showDetailsVisible && (detailsField === 'events' || detailsField === 'packageEvents')"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<FreightLine
					v-if="showDetailsVisible && detailsField === 'freightLines'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<GoodsType
					v-if="showDetailsVisible && detailsField === 'goodsType'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<OrderType
					v-if="showDetailsVisible && detailsField === 'orderType'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<Packages
					v-if="showDetailsVisible && detailsField === 'packages'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<PriceLine
					v-if="showDetailsVisible && detailsField === 'priceLines'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<Transporter
					v-if="showDetailsVisible && detailsField === 'vendor'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
			</template>
		</t-horizontal-panel>
	</t-dialog>
</template>

<script>
import AdditionalReference from './orderChangelog/AdditionalReference';
import Address from './orderChangelog/Address';
import Clerk from './orderChangelog/Clerk';
import Customer from './orderChangelog/Customer';
import Event from './orderChangelog/Event';
import FreightLine from './orderChangelog/FreightLine';
import GoodsType from './orderChangelog/GoodsType';
import OrderType from './orderChangelog/OrderType';
import Packages from './orderChangelog/Packages';
import PriceLine from './orderChangelog/PriceLine';
import Transporter from './orderChangelog/Transporter';
import DetailsCell from './orderChangelog/DetailsCell';
import { storageDateFormat, statuses } from '@/core';
import moment from 'moment';

export default {
	name: 'OrderChangelog',
	components: {
		DetailsCell,
		AdditionalReference,
		Address,
		Clerk,
		Customer,
		Event,
		FreightLine,
		GoodsType,
		OrderType,
		Packages,
		PriceLine,
		Transporter,
	},
	props: {
		isShown: Boolean,
		changelog: Array,
		subOrderTabs: Array
	},
	data() {
		return {
			defaultColumnDefinition: { resizable: false, },
			sort: [{ field: 'changeDate', direction: 'desc' }],
			includeSubOrders: false,
			showDetailsVisible: false,
			detailsObject: {},
			detailsField: '',
			detailsOp: '',
			detailsEnabled: [
				'additionalReferences',
				'consignee',
				'consignor',
				'customer',
				'deliveryParty',
				'despatchParty',
				'events',
				'finalDeliveryParty',
				'freightLines',
				'goodsType',
				'orderType',
				'originalDespatchParty',
				'originalShipper',
				'packageEvents',
				'packages',
				'priceLines',
				'vendor',
			],
			addressFields: ['consignee','consignor','despatchParty','deliveryParty', 'originalShipper', 'finalDeliveryParty', 'originalDespatchParty']
		};
	},
	computed: {
		columnDefinitions() {
			return [
				{
					field: 'changeDate',
					displayName: this.$t('date'),
					valueGetter: (item) => this.getDate(item.changeDate),
					width: 150,
				},
				{
					field: 'clerk',
					valueGetter: item => item.clerk,
					displayName: this.$t('user'),
					width: 200,
				},
				{
					field: 'type',
					displayName: this.$t('changeLocation'),
					valueGetter: (item) => item.type === 'suborder' ? this.getSuborderLabel(item.suborderId) : this.$t(item.type),
					minWidth: 250,
					width: 250,
					resizable: true,
				},
				{
					field: 'field',
					displayName: this.$t('field'),
					valueGetter: (item) => this.$t(item.field),
					minWidth: 300,
					resizable: true,
				},
				{
					field: 'oldValue',
					displayName: this.$t('oldValue'),
					displayValueGetter: (item) => this.formatValue(item.field, item.oldValue),
					comparableValueGetter: (item) => this.getCompareValue(item.field, item.oldValue),
					minWidth: 300,
					resizable: true,
				},
				{
					field: 'value',
					displayName: this.$t('newValue'),
					displayValueGetter: (item) => this.formatValue(item.field, item.value),
					comparableValueGetter: (item) => this.getCompareValue(item.field, item.value),
					minWidth: 300,
					resizable: true,
				},
			];
		},
		filteredChangelog() {
			let showSubOrders = this.includeSubOrders;
			return this.changelog.filter(x => {
				let isOrder = x.type === 'order';
				let isSubOrder = x.type === 'suborder';
				if (x.admin) return false;
				if (x.op === 'remove' && x.oldValue === '') return false;
				return isOrder || (showSubOrders && isSubOrder);
			});
		}
	},
	mounted() {
		let includeSubOrders = localStorage.getItem('orderChangelogIncludeSubOrders');
		if (includeSubOrders === 'true')
			this.toggleIncludeSubOrders(true);
	},
	methods: {
		getSuborderLabel(id) {
			let tab = this.subOrderTabs.find(x => x.id === id);
			if (!tab) return this.$t('removedSuborder');
			return tab.name;
		},
		onClose() {
			this.showGrid = false;
			this.$emit('close');
		},
		isObject(item) {
			return typeof item === 'object' && item !== null;
		},
		getDate(date) {
			return moment(date).format('DD.MM.YYYY HH:mm');
		},
		getEventText(item) {
			return (this.$i18n.locale==='nb-NO' || this.$i18n.locale==='nn-NO' || this.$i18n.locale==='no')
				? (item.info || item.infoEn)
				: (item.infoEn || item.info);
		},
		formatValue(field, value) {
			if (!field || value === null || value === undefined) return value;
			if (field.includes('.date')) return this.getStorageDate(value);
			if (field === 'etd' || field === 'eta' || field === 'atd' || field === 'ata') {
				return this.getStorageDate(value.date);
			}
			if (field === 'billingType') {
				return this.$t(value);
			}
			if (field === 'status') {
				return this.$t(statuses.operational(value));
			}
			if (field === 'economicalStatus') {
				return this.$t(statuses.economical(value));
			}

			return value;
		},
		getCompareValue(field, value) {
			let compValue = this.formatValue(field, value);
			if (compValue === null || compValue === undefined) return value;

			if (this.isObject(compValue)) {
				if (this.isAddressField(field)) {
					return `${compValue.name} ${compValue.street} ${compValue.postalCode} ${compValue.postalPlace}`;
				}
				switch (field) {
				case 'additionalReferences': return compValue.code;
				case 'clerk': return `${compValue.name} ${compValue.email} ${compValue.phoneNumber}`;
				case 'customer': return `${compValue.name} ${compValue.customerNo}`;
				case 'edi.transmissions': return `${this.$t(compValue.type)} ${compValue.messageType}`;
				case 'events':
				case 'packageEvents':
					return `${this.$t(compValue.type)} ${this.getEventText(compValue)}`;
				case 'freightLines': return `${compValue.text} ${compValue.chargeCode}`;
				case 'goodsType': return compValue.name;
				case 'orderType': return compValue.name;
				case 'priceLines': return `${compValue.text} ${compValue.chargeCode}`;
				case 'vendor': return `${compValue.name} ${compValue.vendorNumber}`;
				default: return '';
				}
			}
			return compValue;
		},
		getStorageDate(date) {
			if (!date) return '';
			return moment(date, storageDateFormat).format('DD.MM.YYYY HH:mm');
		},
		showDetails(field, op, data) {
			this.showDetailsVisible = true;
			this.detailsField = field;
			this.detailsOp = op;
			this.detailsObject = data;
		},
		hideDetails() {
			this.showDetailsVisible = false;
			this.detailsField = '';
			this.detailsOp = '';
			this.detailsObject = {};
		},
		allowDetailsButton(field) {
			return this.detailsEnabled.includes(field);
		},
		isAddressField(field) {
			return this.addressFields.includes(field);
		},
		toggleIncludeSubOrders(value = true) {
			this.includeSubOrders = value;
			localStorage.setItem('orderChangelogIncludeSubOrders', value);
		}
	}
};
</script>

<style lang="scss" scoped>
.log {
	height: 100%;
	min-height: inherit;
}

.log-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px;
	background: white;
}

/deep/ .horizontal-panel-content {
	overflow-x:auto;
}

.grid-cell-details {
	display: flex;
	justify-content: space-between;
}

.include-suborders-checkbox {
	padding-left: 20px;
}
</style>
